export class ItemGLSetup {
  hoId: number;
  glCode: string;
  glDesc: string;
  expGL: string;
  grossMargin: boolean;
  idealCost: boolean;
  dailyVariance: boolean;
  removable: boolean;
  codeModified: boolean;
  modified: boolean;
}
